import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteVendaProducaoAgricola } from '../service';
import {
  DELETE_VENDA_PRODUCAO_AGRICOLA,
  DELETE_VENDA_PRODUCAO_AGRICOLA_PENDING,
  DELETE_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
  DELETE_VENDA_PRODUCAO_AGRICOLA_FAILURE,
} from '../actionTypes';

import { AlertError, AlertWarning } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteVendaProducaoAgricola(action) {
  yield put({ type: DELETE_VENDA_PRODUCAO_AGRICOLA_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.VENDA_PROD_AGRICOLA_EXCLUIR);

  try {
    const a = yield call(deleteVendaProducaoAgricola, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_VENDA_PRODUCAO_AGRICOLA_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_VENDA_PRODUCAO_AGRICOLA_FAILURE });

    if (error.response?.status === 409) {
      const mensagem = error.response?.data?.message || 'Não é possível excluir esta venda de produção.';
      AlertWarning(mensagem);
    } else if (error.response?.status === 403) {
      AlertWarning('Venda não pode ser excluída');
    } else {
      AlertError('Falha ao excluir a venda! Tente novamente...');
    }
  }
}

export default function* watchDeleteVendaProducaoAgricola() {
  yield takeLatest(DELETE_VENDA_PRODUCAO_AGRICOLA, sagaDeleteVendaProducaoAgricola)
}
